import Vue from 'vue'
import Router from 'vue-router'

const index = r => require.ensure([], () => r(require('../page/首页')), 'index')
const companyPage = r => require.ensure([], () => r(require('../page/公司页面')), 'companyPage')
const companyActor = r => require.ensure([], () => r(require('../page/公司艺人')), 'companyActor')
const companyBusiness = r => require.ensure([], () => r(require('../page/公司业务')), 'companyBusiness')
const broker = r => require.ensure([], () => r(require('../page/经纪人')), 'broker')
const project = r => require.ensure([], () => r(require('../page/项目')), 'project')
const companyActorOption = r => require.ensure([], () => r(require('../page/公司艺人-选项卡')), 'companyActorOption')
const actorDetail = r => require.ensure([], () => r(require('../page/艺人履历/艺人简介')), 'actorDetail')
const actorExperience = r => require.ensure([], () => r(require('../page/艺人履历/演艺经历')), 'actorExperience')
const programList = r => require.ensure([], () => r(require('../page/艺人履历/演艺经历-节目列表')), 'programList')
const showPics = r => require.ensure([], () => r(require('../page/艺人履历/图片展示.vue')), 'showPics')
const showText = r => require.ensure([], () => r(require('../page/艺人履历/演艺经历-文字介绍.vue')), 'showText')
const brand = r => require.ensure([], () => r(require('../page/艺人履历/合作品牌.vue')), 'brand')
const activity = r => require.ensure([], () => r(require('../page/艺人履历/出席活动.vue')), 'activity')
const winningr = r => require.ensure([], () => r(require('../page/艺人履历/获奖记录.vue')), 'winningr')
const album = r => require.ensure([], () => r(require('../page/艺人履历/平面图集.vue')), 'album')
const music = r => require.ensure([], () => r(require('../page/艺人履历/音乐作品.vue')), 'music')
const winningrLink = r => require.ensure([], () => r(require('../page/艺人履历/获奖记录-link.vue')), 'winningrLink')

Vue.use(Router)

export default new Router({
/*  mode: routerMode,
  saveScrollPosition:true,
  strict: process.env.NODE_ENV !== 'production', */
  routes: [
    {
      path: '',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/companyPage',
      name: 'companyPage',
      component: companyPage
    },
    {
      path: '/companyActor',
      name: 'companyActor',
      component: companyActor
    },
    {
      path: '/companyBusiness',
      name: 'companyBusiness',
      component: companyBusiness
    },
    {
      path: '/broker',
      name: 'broker',
      component: broker
    },
    {
      path: '/project',
      name: 'project',
      component: project
    },
    {
      path: '/companyActorOption',
      name: 'companyActorOption',
      component: companyActorOption
    },
    {
      path: '/actorDetail',
      name: 'actorDetail',
      component: actorDetail
    },
    {
      path: '/actorExperience',
      name: 'actorExperience',
      component: actorExperience
    },
    {
      path: '/programList',
      name: 'programList',
      component: programList
    },
    {
      path: '/showPics',
      name: 'showPics',
      component: showPics
    },
    {
      path: '/showText',
      name: 'showText',
      component: showText
    },
    {
      path: '/brand',
      name: 'brand',
      component: brand
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
    {
      path: '/winningr',
      name: 'winningr',
      component: winningr
    },
    {
      path: '/album',
      name: 'album',
      component: album
    },
    {
      path: '/music',
      name: 'music',
      component: music
    },
    {
      path: '/winningrLink',
      name: 'winningrLink',
      component: winningrLink
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js